var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22H5C4.448 22 4 21.553 4 21V3C4 2.447 4.448 2 5 2H19C19.552 2 20 2.447 20 3V21C20 21.553 19.552 22 19 22ZM6 20H18V4H6V20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H8C7.448 14 7 13.553 7 13V7C7 6.447 7.448 6 8 6H16C16.552 6 17 6.447 17 7V13C17 13.553 16.552 14 16 14ZM9 12H15V8H9V12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H8C7.448 18 7 17.553 7 17C7 16.447 7.448 16 8 16H16C16.552 16 17 16.447 17 17C17 17.553 16.552 18 16 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsset);
export default __webpack_public_path__ + "static/media/icon-asset.909cf205079e3417e7ee74c92bee5492.svg";
export { ForwardRef as ReactComponent };